
import { AdminSidebar } from "@/components/admin/AdminSidebar";
import { ProductForm } from "@/components/admin/products/ProductForm";
import { useNavigate } from "react-router-dom";

export default function ProductsNew() {
  const navigate = useNavigate();

  return (
    <div className="flex bg-background">
      <AdminSidebar />
      
      <div className="flex-1 ml-[250px]">
        <div className="p-6">
          <h1 className="text-3xl font-bold mb-6">Novo Produto</h1>
          
          <div className="max-w-4xl">
            <ProductForm 
              onSuccess={() => navigate('/admin/products/list')}
              onCancel={() => navigate('/admin/products/list')}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
